var map = {
	"./en": [
		"./Scripts/locale/en.js",
		"locale_en"
	],
	"./en.js": [
		"./Scripts/locale/en.js",
		"locale_en"
	],
	"./ja": [
		"./Scripts/locale/ja.js",
		"locale_ja"
	],
	"./ja.js": [
		"./Scripts/locale/ja.js",
		"locale_ja"
	],
	"./zh_CN": [
		"./Scripts/locale/zh_CN.js",
		"locale_zh_CN"
	],
	"./zh_CN.js": [
		"./Scripts/locale/zh_CN.js",
		"locale_zh_CN"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./Scripts/locale lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;